import RecentlyReturnedApi from '../api/RecentlyReturnedApi';
import RecentlyReturnedConstants from '../constants/RecentlyReturnedConstants';

export function fetchReturnHistory(query) {
  return {
    types: [
      RecentlyReturnedConstants.FETCH_RETURN_HISTORY_REQUEST,
      RecentlyReturnedConstants.FETCH_RETURN_HISTORY_SUCCESS,
      RecentlyReturnedConstants.FETCH_RETURN_HISTORY_FAILURE
    ],
    middlewareData: {
      accountRequired: __CLIENT__
    },
    apiRequest: (state, apiClient) =>
      RecentlyReturnedApi.getRecentlyReturned(apiClient, query)
  };
}

export default {
  fetchReturnHistory
};



// WEBPACK FOOTER //
// ./app/actions/RecentlyReturnedActions.js